import { Metamodel } from 'app/model/base/model';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { FLOW } from 'app/model/adapters/dataflow/IDataflow';
import { TransformationAdapter } from 'app/model/adapters/dataflow/transformations/base-transformation.adapter';
import { FilterTransformation } from '../../../dataflow/filtertransformation';
import { DataFlowExpressionUtils } from '../expression.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(FilterTransformation),
    asynchronous: true
})
export class FilterTransformationAdapter extends TransformationAdapter<FilterTransformation> {
    public async getDslScript(filterTransformation: FilterTransformation): Promise<string> {
        const expression = DataFlowExpressionUtils.wrapExpressionWithEmptyValue(
            filterTransformation.condition.expression
        );
        const partition = TransformationAdapter.getPartitionDslScript(filterTransformation);

        const knownProps = `${expression}${expression && partition ? ',\n\t' : ''}${partition}`;
        const unknownProps = this._getUnknownProps(filterTransformation, knownProps);
        const transformationData = [knownProps, unknownProps].filter((c) => !!c).join(',\n\t');

        return (
            `${this._getInputStreams(filterTransformation)}` +
            ` filter(${transformationData}) ${FLOW} ${this._getOutputStreams(filterTransformation)}`
        );
    }
}
